new WOW().init();

jQuery('.slick-banner').slick({
	slidesToShow: 1,
  	slidesToScroll: 1,
  	slide: 'li',
  	dots: true,
  	arrows: false,
  	autoplay: true,
  autoplaySpeed: 3000
  	// adaptiveHeight: true
});

jQuery('.newssilde').slick({
	slidesToShow: 3,
  	slidesToScroll: 1,
  	dots: false,
  	arrows: false,
  	autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
		{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 580,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		]
  	// adaptiveHeight: true
});

jQuery(document).ready(function($){
  // sticky header
  jQuery(window).scroll(function() {
    var topheader = jQuery('#header').height();
    var myheight = jQuery(window).scrollTop();
    if(myheight > topheader){
    	jQuery('.header').addClass('headersticky');
    }
    if(myheight < topheader){
    	jQuery('.header').removeClass('headersticky');
    }
  });

  /**************************************************
   * Turn events-calendar ID into full calendar widget
   **************************************************/
  jQuery('#events-calendar').fullCalendar({
    events: themeforce.events,
    header: {
            left: 'prev,next today',
            center: 'title',
            right: 'month,basicWeek,basicDay'
          },      
  });


  /**************************************************
   * Make row CTAs equal height
   **************************************************/
  var equalRowHeightCta = function(parent, container){
    $(parent).each(function() {
      var currentTallest = 0,
          currentRowStart = 0,
          currentDiv = 0,
          topPostion = 0,
          rowDivs = new Array(),
          $el,
          topPosition = 0;
      $(this).find(container).each(function() {
        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
          for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0; // empty the array
          currentRowStart = topPostion;
          currentTallest = $el.height();
          rowDivs.push($el);
        } else {
          rowDivs.push($el);
          currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    });
  }

  $(window).load(function() {
    var windowWidth = window.innerWidth || $(window).width();
    // Not on mobile
    if(windowWidth > 767) {
      equalRowHeightCta('.newssilde > .slick-track', '.slick-slide .detail');
    }
  });

  $(window).resize(function(){
    var windowWidth = window.innerWidth || $(window).width();
    // Not on mobile
    if(windowWidth > 767) {
      equalRowHeightCta('.newssilde > .slick-track', '.slick-slide .detail');
    }
  });
});